import { render, staticRenderFns } from "./taskResult.vue?vue&type=template&id=b28b4a84&scoped=true&"
import script from "./taskResult.vue?vue&type=script&lang=js&"
export * from "./taskResult.vue?vue&type=script&lang=js&"
import style0 from "./taskResult.vue?vue&type=style&index=0&id=b28b4a84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28b4a84",
  null
  
)

export default component.exports